var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleNewProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#44CD9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.21 19.89L13 29l5-3 5 3-1.21-9.12M25 14a7 7 0 11-14 0 7 7 0 0114 0z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiM0NENEOUMiLz4KPHBhdGggZD0iTTE0LjIxIDE5Ljg5TDEzIDI5TDE4IDI2TDIzIDI5TDIxLjc5IDE5Ljg4TTI1IDE0QzI1IDE3Ljg2NiAyMS44NjYgMjEgMTggMjFDMTQuMTM0IDIxIDExIDE3Ljg2NiAxMSAxNEMxMSAxMC4xMzQgMTQuMTM0IDcgMTggN0MyMS44NjYgNyAyNSAxMC4xMzQgMjUgMTRaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgCircleNewProject as ReactComponent };